import { adapator_createDatabaseRef } from "src/adapters";
import { DB_PATHS } from "src/constants";
import { useUpdateDatabase } from "src/hooks";


const useUpdateSurvey = () => {

    const { setOrUpdateDocument, addDocumentToCollection } =
        useUpdateDatabase();

    async function updateSurveyVersion({ data, currentVersionId }) {
        await setOrUpdateDocument(
            [...DB_PATHS.globalSurveyVersions, currentVersionId],
            data
        );
    }

    async function addNewVersion({ currentVersionId, orgId, metadata, currentVersionIdPath }) {
        const currentVersionS = await adapator_createDatabaseRef([...DB_PATHS.globalSurveyVersions, currentVersionId]).get()
        const currentVersion = currentVersionS.data()

        const { label, description } = metadata

        const newVersionId = await addDocumentToCollection(
            DB_PATHS.globalSurveyVersions,
            {
                ...currentVersion,
                org: orgId,
                createdAt: Date.now(),
                label: label || "",
                description: description || ""
            }
        );

        if (orgId === "global") {
            await setOrUpdateDocument(DB_PATHS.globalSurvey, {
                currentGlobalVersion: newVersionId,
            });

        } else {
            await setOrUpdateDocument(currentVersionIdPath, {
                currentVersion: newVersionId,
            });
        }
    }


    return {
        updateSurveyVersion,
        addNewVersion
    }
}

export default useUpdateSurvey